import React, { useState, useMemo } from 'react';
import { gallery, galleryCategories } from '../mock';

const Gallery = () => {
  const [active, setActive] = useState('All');

  const filtered = useMemo(() => {
    if (active === 'All') return gallery;
    return gallery.filter((g) => g.category === active);
  }, [active]);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-gradient-to-b from-pink-50/60 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="inline-flex items-center gap-2 bg-white border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
            OUR WORK
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900">
            <span className="gradient-text">Gallery</span>
          </h2>
          <p className="mt-4 text-gray-600 text-lg">Explore our stunning nail designs</p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-10">
          {galleryCategories.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition-all duration-200 ${
                active === c
                  ? 'bg-gradient-to-r from-pink-500 to-rose-500 text-white border-transparent shadow-md'
                  : 'bg-white text-gray-600 border-pink-200 hover:border-pink-400 hover:text-pink-600'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="gallery-item shadow-md border border-pink-100 bg-white"
            >
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-52 sm:h-60 md:h-64 object-cover"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <span className="text-white font-semibold text-sm bg-pink-600/70 backdrop-blur px-3 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
